import { render, staticRenderFns } from "./ChangeVesselTypeDropdown.vue?vue&type=template&id=55d526bc"
import script from "./ChangeVesselTypeDropdown.vue?vue&type=script&lang=js"
export * from "./ChangeVesselTypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports